import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SignInPage from './SignInPage/SignInPage';

const SignInFeature: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <SignInPage />
      </Route>
    </Switch>
  );
};

export default SignInFeature;
